/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const CASHIER_SUPERVISOR_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "PaymentReport"],
  ["read", "PaymentTransaction"],
  ["read", "CashierPayment"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "Masquerader"],
  ["read", "UserList"],
  ["read", "BlackListUsers"],
  ["read", "Committe"],
  ["read", "Presentation"],
  ["read", "InventoryView"],
  ["read", "InviteCommitteMember"],
  ["read", "Invite"],
  ["read", "InviteMasqueraderPurchase"],
  ["read", "MasqueraderList"],
  ["read", "CommitteList"],
  ["read", "CashierList"],
  ["read", "CommDisList"],
  ["read", "DeletedBox"],
  ["read", "UpdatedBox"],
  ["read", "DeletedViewBox"],
  ["read", "PresentationList"],
  ["read", "PresentationInventory"],
  ["read", "OrgProfile"],
  ["read", "SectionOptionInventory"],
  ["read", "InventoryControl"],
  ["read", "MasqueraderReport"],
  ["read", "PurchasedCostume"],
  ["read", "ViewBoxDetails"],
  ["read", "ViewMasqBoxDetails"],
  ["read", "ChangeCostumeOptions"],
  ["read", "SwitchSection"],
  ["read", "MasqViewBox"],
  ["read", "MasqBoxList"],
  ["read", "SectionBasePriceSummary"],
  ["read", "CashierPurchasedCostume"],
  // ["read", "CommitteReport"],
  ["read", "CommitteMemberReport"],
  ["read", "DiscountInvite"],
  ["read", "CreateMasqBox"],
  ["read", "ZeroPaymentReport"],
  ["read", "PartialPaymentReport"],
  ["read", "FullPaymentReport"],
  ["read", "DiscountReport"],
  ["read", "SalesReport"],
  ["read", "OpenRegisterFlair"],
  ["read", "OpenRegisterElektra"],
  ["read", "OpenRegisterScorch"],
  ["read", "OpenRegisterTravisWorld"],
  ["read", "OpenRegisterBattalionMusic"],
  ["read", "OpenRegisterGenx"],
  ["read", "OpenRegisterTriniJungleJuice"],
  ["read", "OpenRegisterIslandCrashers"],
  ["read", "OpenRegisterLil"],
  ["read", "OpenRegisterSolangeGovia"],
  ["read", "OpenRegisterAbsolute"],
  ["read", "OpenRegisterEnergy"],
  ["read", "OpenRegisterHouseOfBachannal"],
  ["read", "OpenRegisterDLux"],
  ["read", "OpenRegisterPunchyPunch"],
  ["read", "OpenRegisterLauraNa"],
  ["read", "OpenRegisterChandraMaharaj"],
  ["read", "OpenRegisterShawnDhanraj"],
  ["read", "OpenRegisterMADJouvert"],
  ["read", "OpenRegisterBikiniCabana"],
  ["read", "OpenRegisterFarmhouse"],
  ["read", "OpenRegisterJCAMFitness"],
  ["read", "OpenRegisterIImagine"],
  ["read", "OpenRegisterKRISP"],
  ["read", "OpenRegisterKristenCamacho"],
  ["read", "OpenRegisterLiveInLove"],
  ["read", "OpenRegisterMarkCorreia"],
  ["read", "OpenRegisterMixedNutz"],
  ["read", "OpenRegisterRoyale"],
  ["read", "OpenRegisterWinerboy"],
  ["read", "OpenRegisterMVP"],
  ["read", "OpenRegisterNatalieFonrose"],
  ["read", "OpenRegisterDavidDewer"],
  ["read", "OpenRegisterTribeU"],
  ["read", "OpenRegisterClubhouse"],
  ["read", "OpenRegisterMidnight"],
  ["read", "OpenRegisterMarieange"],
  ["read", "OpenRegisterLivinLocal"],
  ["read", "OpenRegisterDean"],
  ["read", "OpenRegisterMonique"],
  ["read", "OpenRegisterGerard"],
  ["read", "OpenRegisterMelissa"],
  ["read", "OpenRegisterLana"],
  ["read", "OpenRegisterGail"],
  ["read", "OpenRegisterDwayne"],
  ["read", "OpenRegister"],
  ["read", "ManageOpenRegistration"],
  ["read", "FHPolicy"],
  ["read", "ProfileUpdateStepper"],
  ["read", "AboutMe"],
  ["read", "CostumeInventoryReport"],
  ["read", "SectionOptInvReport"],
  ["read", "DeliveredReport"],
  ["read", "InviteesList"],
  ["read", "PrintLabels"],
  ["read", "ScheduleTable"],
  ["read", "ShelfList"],
  ["read", "ScheduleList"],
  ["read", "ShelfDetail"],
  ["read", "BoxDetail"],
  ["read", "MasqInvitationWithDiscountTemplate"],
  ["read", "OTPTemplate"],
  ["read", "MasqInvitationTemplate"],
  ["read", "DiscountCodeTemplate"],
  ["read", "CommitteeInvitationTemplate"],
  ["read", "MasqDownPaymentTemplate"],
  ["read", "DeletedBoxTemplate"],
  ["read", "AdminInvitationTemplate"],
  ["read", "DiscountInviteTemplate"],
  ["read", "CashierInviteTemplate"],
  ["read", "CostumePurchaseInviteTemplate"],
  ["read", "InvoiceTemplate"],
  ["read", "TransferBoxNewUserTemplate"],
  ["read", "TransferBoxOldUserTemplate"],
  ["read", "CommonEmailVerificationTemplate"],
  ["read", "PreBookInviteTemplate"],
  ["read", "PreBookDownPaymentEmailTemplate"],
  ["read", "PartialRemainderEmailTemplate"],
  ["read", "UnPaidRemainderEmailTemplate"],
];

export const CASHIER_SUPERVISOR_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
  ["read", "Costume"],
  ["read", "CostumeOpenReg"],
  ["read", "OpenRegistrationCostumePage"],
  ["read", "InviteList"],
  ["read", "Purchase"],
];
